import { FC, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { RenderNextStepProps } from "./types";
import {  PrecertAPIResponse } from "../precert/types";
import { LoaderContext } from "src/context/loaderContext";
// import useAppealButtonFunc from "src/hooks/useAppealButtonFunc";



const RenderNextStep: FC<RenderNextStepProps> = ({ kase , showHideModalForTreatment, setDataForCancelModal, getCaseListing }): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();


  const buyAndBillButton = (caseID:number) => {
    updateCaseMutate({case:{status_name:"Pulled From Stock",color_idx:3}},{caseId:caseID},{})
    navigate(`/cases/detail/${caseID}`);
  }

  const { mutate: updateCaseMutate, data: updateCaseResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_CASES, {}, {}, false);

  useEffect(() => {
    if (updateCaseResponse) {
      navigate(`/cases`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCaseResponse]);


  const { loading: transferRxLoading, data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX, {}, { case_id: kase.id });

  useEffect(() => {
    if (transferRxData) {
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      getCaseListing();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  useEffect(() => {
    if (transferRxLoading) setLoader();
    else hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxLoading]);

  const ConfirmAlert = (title: string,buttonName:string,caseId:number ) => {

    const result = window.confirm(title);
    if (result) {
      if(buttonName === 'xFerToSP'){
        transferRxByCaseId({},{case_id: caseId})
      }
    }
  };



  const caseAction = [];

  if (kase.xfer_to_sp) {
    caseAction.push(
      <button
        key={caseAction.length}
        className="btn btn-success m-1"
        onClick={() => ConfirmAlert('Are you sure you want to transfer this prescription? This cannot be undone!',"xFerToSP",kase.id)}
      >
        <i className="fas fa-prescription"></i> Xfer to SP
      </button>)
  }
  if (kase.buy_and_bill) {
    caseAction.push(
      <button
        className="btn btn-success m-1"
        key={caseAction.length}
        onClick={() => { buyAndBillButton(kase.id) }}
      >
        <i className="bi bi-hospital me-2"></i> Buy & Bill
      </button>)
  }
  if (caseAction.length === 0 && !kase.empty_next_step) {
    caseAction.push(<p key={caseAction.length} className="mb-0">No Action Required</p>);
  }

  return (
    <>
      {caseAction}
    </>
  );
};

export default RenderNextStep;
